export const RECEIVE_PROVIDERS = 'RECEIVE_PROVIDERS'
export const RECEIVE_PROVIDER = 'RECEIVE_PROVIDER'
export const RECEIVE_PROVIDERS_ERROR = 'RECEIVE_PROVIDERS_ERROR'
export const CLEAR_PROVIDERS = 'CLEAR_PROVIDERS'
export const DELETE_RELATED_PROVIDER_CONTENT = 'DELETE_RELATED_PROVIDER_CONTENT'
export const RECEIVE_RELATED_PROVIDER_CONTENT = 'RECEIVE_RELATED_PROVIDER_CONTENT'
